<template>
  <f7-row class="mb-05 pb-05 pt-05 pl-05 pr-05">
    <f7-col width="40" class="p-0">
      <small>{{ source.timestamp | moment('YYYY-MM-DD HH:mm:ss') }}</small>
    </f7-col>
    <f7-col width="20" class="text-align-center p-0">
      <small>{{ source.duration * 1000 | duration('humanize') }}</small>
    </f7-col>
    <f7-col class="text-align-right p-0">
      <small>{{ source.amount / config.point | numeral(config.numeral) }}</small>
    </f7-col>
    <f7-col width="20" class="overflow-hide text-align-right pl-1 p-0">
      <small>{{ source.tx.substr(0, 6) }}&nbsp;&nbsp;</small>
    </f7-col>
  </f7-row>
</template>
<style scoped>
small {
  font-size : 9px;
}
small.xs {
  font-size : 8px;
}
.overflow-hide {
  overflow : hidden;
}
</style>
<script>
import { f7Row, f7Col } from 'framework7-vue';

export default {
  components: {
    f7Row,
    f7Col
  },
  props: {
    source: {
      type: Object,
      default() {
        return {}
      }
    },
    config: {
      type: Object,
      default() {
        return {}
      }
    }
  }
}
</script>
